import { PlusCircleOutlined } from '@ant-design/icons'
import { Divider, Row, Space } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import useLineItemUpdate from 'app/components/Core/Checkout/hooks/useLineItemUpdate'
import useMachineSearch from 'app/components/Core/Checkout/hooks/useMachineSearch'
import { useProductIndex } from 'app/components/Core/Checkout/hooks/useProduct'
import DetailItem from 'app/components/Core/LineItem/Item/Detail'
import KButton from 'app/components/Modules/General/KButton'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import { RecordType } from 'app/constants/GlobalTypes'
import { useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const Overview: React.FC = () => {
  const { checkout_id: rental_id } = useParams<{ checkout_id: string }>()
  const navigate = useNavigate()
  const { goBack } = useBrowserRouterContext()
  const { md } = useBreakpoint()
  const { open } = useLineItemUpdate()
  const { open: openMachineSearch } = useMachineSearch()
  const { data } = useProductIndex({ id: rental_id })

  const onEdit = (item: ILineItem) => {
    open({ lineItemId: item.id })
  }

  const onNext = () => {
    navigate(Routes.Checkout.member(rental_id).delivery)
  }

  return (
    <>
      <Row>
        <KCol span={24}>
          {data.map((item) => (
            <DetailItem key={item.id} member={item} props={{ onClick: () => onEdit(item) }} />
          ))}
          <Divider />
        </KCol>
        <KCol className="text-center mb-4" span={24}>
          <KButton
            type="secondary"
            onClick={() => openMachineSearch()}
            action="add_machine"
            recordType={RecordType.checkout}
            icon={<PlusCircleOutlined />}
          />
        </KCol>
      </Row>
      <KFooter sticky={!md} removePadding={md}>
        <Space>
          <If condition={md}>
            <KButton
              type="secondary"
              onClick={goBack}
              recordType={RecordType.checkout}
              action="back_to_address"
            />
          </If>
          <KButton
            type="primary"
            onClick={onNext}
            action="to_delivery_step"
            recordType={RecordType.checkout}
          />
        </Space>
      </KFooter>
    </>
  )
}

export default Overview
